import { useEffect } from "react";
import { getSocket } from "@/lib/socket";

export function useSocketEvent<T = any>(
  event: string,
  callback: (data: T) => void,
  dependencies: any[] = [],
  /** Pass socket from useSocket() so the effect re-runs when socket connects (e.g. after auth). */
  socketFromParent?: ReturnType<typeof getSocket>
) {
  useEffect(() => {
    const socket = socketFromParent ?? getSocket();
    if (!socket) {
      return;
    }

    socket.on(event, callback);

    return () => {
      socket.off(event, callback);
    };
  }, [event, ...dependencies, socketFromParent]);
}

